import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@customizer.app");
  const [password, setPassword] = useState("Admin@12345");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/dashboard");
    } catch (e) {
      const d = e.response?.data?.detail;
      const msg = typeof d === "string" ? d : "Login failed";
      setErr(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="brutal-card p-8">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-stone-600 mb-1">Seller login</div>
          <h1 className="font-heading font-black text-4xl mb-6">Welcome back.</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest mb-1 block">Email</label>
              <input
                data-testid="login-email"
                type="email" required autoFocus
                className="brutal-input w-full"
                value={email} onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest mb-1 block">Password</label>
              <input
                data-testid="login-password"
                type="password" required
                className="brutal-input w-full"
                value={password} onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {err && <div className="text-sm text-red-700 font-bold" data-testid="login-error">{err}</div>}
            <button
              type="submit" disabled={busy}
              className="brutal-btn bg-yellow-300 w-full py-3 rounded-md"
              data-testid="login-submit"
            >
              {busy ? "Logging in…" : "Log in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
